import request from '@/utils/request'
// import request1 from '@/utils/request1'
import { getToken } from '../utils/auth'
// 服务商接单
// 查询服务商 新
export function querysupplierorgnotype (params) {
  params.token = getToken()
  return request({
    url: '/querysupplierorgnotype',
    method: 'post',
    params
  })
}
// 查询服务商 旧
export function querysupplierorg () {
  return request({
    url: '/querysupplierorg',
    method: 'post',
    params: { token: getToken() }
  })
}
// 新建服务商
export function addsupplierorg (data) {
  return request({
    url: '/addsupplierorg',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新服务商
export function updatesupplierorg (data) {
  return request({
    url: '/updatesupplierorg',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除服务商
export function deletesupplierorg (data) {
  return request({
    url: '/deletesupplierorg',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 服务商人员管理
// 服务商人员数据
export function querysupplierorgperson (data) {
  return request({
    url: '/querysupplierorgperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
export function querysupplierorgpersonbyso (data) {
  return request({
    url: '/querysupplierorgpersonbyso',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 新建服务商人员
export function addsupplierorgperson (data) {
  return request({
    url: '/addsupplierorgperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新服务商人员
export function updatesupplierorgperson (data) {
  return request({
    url: '/updatesupplierorgperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除服务商人员
export function deletesupplierorgperson (data) {
  return request({
    url: '/deletesupplierorgperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 批量替换服务单中的服务人员
export function batchreplacesupplierperson (data) {
  return request({
    url: '/batchreplacesupplierperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 服务类型
// 服务类型数据
export function querysuppliertype (params, data) {
  params.token = getToken()
  return request({
    url: '/querysuppliertype',
    method: 'post',
    params,
    data
  })
}
// 新建服务类型
export function addsuppliertype (data) {
  return request({
    url: '/addsuppliertype',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新服务类型
export function updatesuppliertype (data) {
  return request({
    url: '/updatesuppliertype',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除服务类型
export function deletesuppliertype (data) {
  return request({
    url: '/deletesuppliertype',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 服务内容
// 服务内容获取服务商
export function querysupplierorgbystid (params, data) {
  params.token = getToken()
  return request({
    url: '/querysupplierorgbystid',
    method: 'post',
    params,
    data
  })
}
// 服务商提供服务数据 新
export function querysupplierservice (params, data) {
  params.token = getToken()
  return request({
    url: '/querysupplierservice',
    method: 'post',
    params,
    data
  })
}
// 服务商提供服务数据 旧
export function querysuppliertypeorg () {
  return request({
    url: '/querysuppliertypeorg',
    method: 'post',
    params: { token: getToken() }
  })
}
// 新建修改服务商提供服务 新
export function addsupplierservice (data) {
  return request({
    url: '/addsupplierservice',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 新建服务商提供服务 旧
export function addsuppliertypeorg (data) {
  return request({
    url: '/addsuppliertypeorg',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新服务商提供服务 旧
export function updatesuppliertypeorg (data) {
  return request({
    url: '/updatesuppliertypeorg',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除服务商提供服务 新
export function deletesupplierservice (data) {
  return request({
    url: '/deletesupplierservice',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除服务商提供服务 旧
export function deletesuppliertypeorg (data) {
  return request({
    url: '/deletesuppliertypeorg',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 服务单列表
export function querypersonsupplierservice (params, data) {
  params.token = getToken()
  return request({
    url: '/querypersonsupplierservice',
    method: 'post',
    params,
    data
  })
}
// 发起老人服务单
export function addpersonsupplierservice (data) {
  return request({
    url: '/addpersonsupplierservice',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 更新老人服务单
export function updatepersonsupplierservice (data) {
  return request({
    url: '/updatepersonsupplierservice',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 结束老人服务单
export function deletepersonsupplierservice (data) {
  return request({
    url: '/deletepersonsupplierservice',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 处理服务单
export function createpersonsupplierservicerecords (data) {
  return request({
    url: '/createpersonsupplierservicerecords',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 处理服务单
export function handlesupplierservicerecord (data) {
  return request({
    url: '/handlesupplierservicerecord',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// /updatepersonsupplierservicerecordsbasic 修改服务记录
export function updatepersonsupplierservicerecordsbasic (data) {
  return request({
    url: '/updatepersonsupplierservicerecordsbasic',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 获取老人服务记录
export function querypersonsupplierservicerecords (params, data) {
  params.token = getToken()
  return request({
    url: '/querypersonsupplierservicerecords',
    method: 'post',
    params,
    data
  })
}
// 待审核服务单列表
export function querypersonsupplierservicecheckinfo (params, data) {
  params.token = getToken()
  return request({
    url: '/querypersonsupplierservicecheckinfo',
    method: 'post',
    params,
    data
  })
}
// 审核服务单
export function approvepersonsupplierservicecheckinfo (data) {
  return request({
    url: '/approvepersonsupplierservicecheckinfo',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查询是否有缴费提醒
export function querypersoncarefeeremindervaliddate (data) {
  return request({
    url: '/querypersoncarefeeremindervaliddate',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查询缴费提醒
export function querypersoncarefeereminders (params, data) {
  params.token = getToken()
  return request({
    url: '/querypersoncarefeereminders',
    method: 'post',
    params,
    data
  })
}
// 新增缴费
export function createpersoncarefeepayment (data) {
  return request({
    url: '/createpersoncarefeepayment',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 编辑费用
export function updatepersoncarefeereminder (data) {
  return request({
    url: '/updatepersoncarefeereminder',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 终止费用
export function deletepersoncarefeereminder (data) {
  return request({
    url: '/deletepersoncarefeereminder',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 缴费记录
export function querypersoncarefeepaymentshistory (params, data) {
  params.token = getToken()
  return request({
    url: '/querypersoncarefeepaymentshistory',
    method: 'post',
    params,
    data
  })
}
// ===================== 服务包 =====================
// 查询服务包列表
export function querypersonservicepackage (params, data) {
  params.token = getToken()
  return request({
    url: '/querypersonservicepackage',
    method: 'post',
    params,
    data
  })
}
// 创建服务包（可同时关联老人）
export function createpersonservicepackage (data) {
  return request({
    url: '/createpersonservicepackage',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 修改服务包
export function updatepersonservicepackage (data) {
  return request({
    url: '/updatepersonservicepackage',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除服务包
export function deletepersonservicepackage (data) {
  return request({
    url: '/deletepersonservicepackage',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查询服务包下的老人列表
export function querypersonservicepackageperson (params, data) {
  params.token = getToken()
  return request({
    url: '/querypersonservicepackageperson',
    method: 'post',
    params,
    data
  })
}
// 向服务包批量添加老人
export function addpersonservicepackageperson (data) {
  return request({
    url: '/addpersonservicepackageperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 从服务包移除老人
export function removepersonservicepackageperson (data) {
  return request({
    url: '/removepersonservicepackageperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 服务包续期
export function renewpersonservicepackageperson (data) {
  return request({
    url: '/renewpersonservicepackageperson',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// ===== 服务项目包 =====
// 查询服务项目包列表
export function queryserviceprojectbundle (params, data) {
  params.token = getToken()
  return request({
    url: '/queryserviceprojectbundle',
    method: 'post',
    params,
    data
  })
}
// 创建服务项目包
export function createserviceprojectbundle (data) {
  return request({
    url: '/createserviceprojectbundle',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 修改服务项目包
export function updateserviceprojectbundle (data) {
  return request({
    url: '/updateserviceprojectbundle',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 删除服务项目包
export function deleteserviceprojectbundle (data) {
  return request({
    url: '/deleteserviceprojectbundle',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 服务项目包看板（汇总）
export function queryserviceprojectbundlekanban (params, data) {
  params.token = getToken()
  return request({
    url: '/queryserviceprojectbundlekanban',
    method: 'post',
    params,
    data
  })
}
// 查询服务包分配老人的服务单列表（按 spp_id 过滤）
export function querypersonservicepackageorders (params, data) {
  params.token = getToken()
  return request({
    url: '/querypersonservicepackageorders',
    method: 'post',
    params,
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/serviceMark.js